// ContactsPage.jsx
import React from 'react'
import './ContactsPage.css'
import SocialIcons from '../components/SocialIcons'

export default function ContactsPage() {
    return (
        <main className='main'>
            <div className='container'>
                <section className='contacts-section styled-card'>
                    <h1 className='contacts-title'>Contacts</h1>
                    <p className='contacts-description'>
                        Have questions or ideas? Whether you're a player, journalist, or
                        business partner, we’d love to hear from you! Reach out, and
                        let’s create something amazing together.
                    </p>
                    <div className='contacts-card-emails'>
                        <div className='contacts-card-email'>
                            <img
                                src='/images/email.png'
                                alt='email icon'
                                width='24'
                                height='24'
                                className='contacts-email-icon'
                            />
                            <a
                                href='mailto:qcat.studio@gmail.com'
                                className='contacts-email-text'
                            >
                                qcat.studio@gmail.com
                            </a>
                            <span className='contacts-email-note'>
									– For business, press, and general questions.
								</span>
                        </div>
                        <div className='contacts-card-email'>
                            <img
                                src='/images/email.png'
                                alt='email icon'
                                width='24'
                                height='24'
                                className='contacts-email-icon'
                            />
                            <a
                                href='mailto:qcat.studio.sup@gmail.com'
                                className='contacts-email-text'
                            >
                                qcat.studio.sup@gmail.com
                            </a>
                            <span className='contacts-email-note'>
									– For technical issues and game support.
								</span>
                        </div>
                    </div>
                </section>
            </div>
            <SocialIcons/>
            <div style={{marginBottom: '12rem'}}/>
        </main>

    )
}
